var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDischargesR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.667236,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#EE0020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11063 5.35124C6.29463 5.31924 6.49063 5.29124 6.69863 5.26724C6.91463 5.23524 7.12663 5.21124 7.33463 5.19524C7.55063 5.17924 7.75863 5.16724 7.95863 5.15924C8.15863 5.15124 8.34263 5.14724 8.51063 5.14724C8.90263 5.14724 9.28663 5.18324 9.66263 5.25524C10.0466 5.32724 10.3866 5.45124 10.6826 5.62724C10.9866 5.80324 11.2266 6.04724 11.4026 6.35924C11.5866 6.66324 11.6786 7.04724 11.6786 7.51124C11.6786 8.19924 11.5186 8.75924 11.1986 9.19124C10.8786 9.62324 10.4506 9.92324 9.91463 10.0912L10.5026 10.4632L12.4226 13.6672H10.5266L8.61863 10.3792L7.75463 10.2232V13.6672H6.11063V5.35124ZM8.63063 6.61124C8.46263 6.61124 8.29463 6.61524 8.12663 6.62324C7.96663 6.63124 7.84263 6.64724 7.75463 6.67124V9.10724H8.45063C8.90663 9.10724 9.27063 9.00324 9.54263 8.79524C9.81463 8.58724 9.95063 8.24324 9.95063 7.76324C9.95063 7.40324 9.83863 7.12324 9.61463 6.92324C9.39063 6.71524 9.06263 6.61124 8.63063 6.61124Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargesR);
export default __webpack_public_path__ + "static/media/discharges-r.96cd7239dc8bf704ea98a9b5934b0189.svg";
export { ForwardRef as ReactComponent };